import configApi from "../configApi";

const sectionBaseURL = "/api/user";
const restAuthBaseURL = "/rest-auth";

const apiAuth = {
  login: async (email, password) => {
    return configApi.post(`${sectionBaseURL}/token/`, { email, password });
  },

  me: async () => {
    return configApi.get(`${sectionBaseURL}/me/`);
  },

  updateMe: async ({ password, email, screen_name, ig_profile, bio }) => {
    const payload = {
      password,
      email,
      profile: {
        screen_name,
        ig_profile,
        bio,
      },
    };
    return configApi.patch(`${sectionBaseURL}/me/`, payload);
  },

  passwordReset: async (email) => {
    return configApi.post(`${restAuthBaseURL}/password/reset/`, { email });
  },

  passwordResetConfirmation: async (newPassword, newPassword2, uid, token) => {
    return configApi.post(`${restAuthBaseURL}/password/reset/confirm/`, {
      new_password1: newPassword,
      new_password2: newPassword2,
      uid,
      token,
    });
  },
};

export default apiAuth;
